<template>
  <div class="filters">
    <div class="inputBlock" v-for="(input, key) in data" :key="key">
      <Ui :data="input" @set="$emit('set', {key: key, value: $event})" />
    </div>
  </div>
</template>

<script>
import Ui from '@/components/Ui'

export default {
  components: {
    Ui
  },
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped>
.filters{
  @include box(100%, auto, relative, null, null, null, null, null, null);
  @include flex(left, center, row);
  .inputBlock{
    @include box(100%, auto, relative, null, null, null, null, null, null);
    &:nth-child(1) {
      @include size(20%, null);
      @include margin(0, 0, 1vw, 0);
    }
    &:nth-child(2) {
      @include size(20%, null);
      @include margin(1vw, 0, 1vw, 0);
    }
    &:nth-child(3) {
      @include size(20%, null);
      @include margin(1vw, 0, 1vw, 0);
    }
    &:nth-child(4) {
      @include size(20%, null);
      @include margin(1vw, 0, 1vw, 0);
    }
    &:nth-child(5) {
      @include size(20%, null);
      @include margin(1vw, 0, 0, 0);
    }
  }
}
</style>
